module.exports = "/virtual-football/img/video/clubs/germany/dortmund.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/germany/dortmund.png
// module id = 295
// module chunks = 6